export default __webpack_public_path__ + "static/media/att_prop.09f52ed6.svg";